import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const timezoneService = {
  getFromAddress: (addressId) =>
    api.getCall(`/api/timezone/from-address/${addressId}`),
  getFromGeocode: (lat, lng) =>
    api.getCall("/api/timezone/from-geocode", { lat, lng }),
};
